import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import { BiMessageDetail, BiSpreadsheet } from 'react-icons/bi';
import { AiOutlinePlus, AiOutlineMenu, AiOutlineEye } from 'react-icons/ai';
import { MdInfoOutline } from 'react-icons/md';
import axios from 'axios';
import { FaCheck, FaClock, FaQuestionCircle, FaRegCopy, FaTrash } from 'react-icons/fa';
import { CiMenuKebab } from "react-icons/ci";
import { v4 as uuidv4 } from 'uuid';
import { Dropdown } from 'react-bootstrap';
import { HiArrowDown } from "react-icons/hi2";

const Quiz = () => {
    const [user, setUser] = useState(null);
    const [token, setToken] = useState(null);
    const [events, setEvents] = useState([]);
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [addingQuiz, setAddingQuiz] = useState(false);
    const [step, setStep] = useState(0);
    const [quizTitle, setQuizTitle] = useState('');
    const [quizTimer, setQuizTimer] = useState(20);
    const [quizQuestion, setQuizQuestion] = useState('');
    const [options, setOptions] = useState(['', '']);
    const [correctAnswerIndex, setCorrectAnswerIndex] = useState(null);

    useEffect(() => {
        const storedUser = sessionStorage.getItem('user');
        const storedToken = sessionStorage.getItem('token');
        if (storedUser) setUser(JSON.parse(storedUser));
        if (storedToken) setToken(storedToken);
    }, []);

    useEffect(() => {
        if (user?.id) fetchEvents();
    }, [user]);

    const fetchEvents = async () => {
        try {
            const response = await axios.get(`https://rvapi.emedha.in/pages/api/api/events?userId=${user.id}`);
            setEvents(response.data);
        } catch (error) {
            console.error(error);
        }
    };
    const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
    const addOption = () => setOptions([...options, '']);
    const updateOption = (index, value) => {
        const newOptions = [...options];
        newOptions[index] = value;
        setOptions(newOptions);
    };

    const handleTitleSubmit = (e) => {
        e.preventDefault();
        if (!quizTitle.trim()) return alert('Please enter quiz title');
        setStep(2);
    };


    const [submittedQuizzes, setSubmittedQuizzes] = useState([]);

    const handleQuizSubmit = async () => {
        if (!quizQuestion.trim()) return alert('Please enter quiz question');
        if (options.some((opt) => !opt.trim())) return alert('Please fill all options');
        if (correctAnswerIndex === null) return alert('Please select the correct answer');
        const newQuestion = {
            question: quizQuestion,
            options,
            correctAnswer: correctAnswerIndex,
            timer: quizTimer,
        };
        const quizId = quizTitle.replace(/\s+/g, '-').toLowerCase() + '-' + uuidv4();
        let updatedQuizzes = [...submittedQuizzes];
        const existingQuizIndex = submittedQuizzes.findIndex(q => q.title === quizTitle);
        if (existingQuizIndex !== -1) {
            updatedQuizzes[existingQuizIndex].questions.push(newQuestion);
        } else {
            updatedQuizzes.push({
                id: quizId,
                title: quizTitle,
                questions: [newQuestion]
            });
        }
        setSubmittedQuizzes(updatedQuizzes);
        setQuizQuestion('');
        setOptions(['', '']);
        setCorrectAnswerIndex(null);
        setQuizTimer(20);
        try {
            const quizToSave = updatedQuizzes.find(q => q.title === quizTitle);
            await axios.post('https://rvapi.emedha.in/pages/api/api/quiz', {
                id: quizToSave.id,
                title: quizToSave.title,
                userId: user.id,
                questions: quizToSave.questions
            });
            console.log('Quiz saved to backend');
        } catch (err) {
            console.error('Error saving quiz to backend:', err);
            alert('Failed to save quiz to server.');
        }
    };

    const [fetchedQuizzes, setFetchedQuizzes] = useState([]);
    const [expandedQuizId, setExpandedQuizId] = useState(null);
    const [expandedQuizId1, setExpandedQuizId1] = useState(null);

    const fetchQuizzes = async () => {
        if (!user?.id) return;
        try {
            const response = await axios.get(`https://rvapi.emedha.in/pages/api/api/quiz?userId=${user.id}`);
            setFetchedQuizzes(response.data || []);
        } catch (err) {
            console.error('Failed to fetch quizzes:', err);
        }
    };
    useEffect(() => {
        fetchQuizzes();
    }, [user]);

    const deleteOption = (index) => {
        if (options.length <= 2) return alert('At least two options are required');
        const newOptions = options.filter((_, i) => i !== index);
        setOptions(newOptions);
        if (correctAnswerIndex === index) {
            setCorrectAnswerIndex(null);
        } else if (correctAnswerIndex > index) {
            setCorrectAnswerIndex(correctAnswerIndex - 1);
        }
    };

    const handleDeleteQuiz = async (quizId) => {
        if (!window.confirm('Are you sure you want to delete this quiz?')) return;
        try {
            await axios.delete(`https://rvapi.emedha.in/pages/api/api/quiz/${quizId}`);
            setFetchedQuizzes(prev => prev.filter(q => q.id !== quizId));
            alert('Quiz deleted successfully.');
        } catch (error) {
            console.error('❌ Failed to delete quiz:', error);
            alert('Failed to delete quiz. Try again.');
        }
    };

    const [activeChatQuizId, setActiveChatQuizId] = useState(null);
    const [participants, setParticipants] = useState({});
    const [expandedParticipantQuizId, setExpandedParticipantQuizId] = useState(null);

    const [liveFetching, setLiveFetching] = useState(false);
    const [participantIntervalId, setParticipantIntervalId] = useState(null);

    const fetchParticipants = async (quizId) => {
        try {
            const res = await axios.get(`https://rvapi.emedha.in/pages/api/api/participants/${quizId}`);
            setParticipants(prev => ({ ...prev, [quizId]: res.data }));
            setExpandedParticipantQuizId(prev => (prev === quizId ? null : quizId));
        } catch (err) {
            console.error('Error fetching participants:', err);
            alert('Failed to load participants.');
        }
    };


    useEffect(() => {
        if (!activeChatQuizId || !liveFetching) return;
        const intervalId = setInterval(() => {
            fetchParticipants(activeChatQuizId);
        }, 2000); // fetch every 2 seconds     
        setParticipantIntervalId(intervalId);
        return () => clearInterval(intervalId);
    }, [activeChatQuizId, liveFetching]);


    const [results, setResults] = useState([]);
    useEffect(() => {
        if (!activeChatQuizId) return;
        fetch(`https://rvapi.emedha.in/pages/api/api/quiz_answers/${activeChatQuizId}`)
            .then((res) => res.json())
            .then((data) => {
                setResults(data);
            });
    }, [activeChatQuizId]);

    const getInitials = (fullName) => {
        const words = fullName.trim().split(' ');
        if (words.length === 1) return words[0][0].toUpperCase();
        return (words[0][0] + words[words.length - 1][0]).toUpperCase();
    };

    const getOrdinal = (n) => {
        const ordinals = ['First', 'Second', 'Third', 'Fourth', 'Fifth', 'Sixth', 'Seventh', 'Eighth', 'Ninth', 'Tenth'];
        return ordinals[n] || `${n + 1}th`;
    };

    const handleNextQuestion = async (quizId) => {
        try {
            // ❌ Stop live fetching
            setLiveFetching(false);
            if (participantIntervalId) clearInterval(participantIntervalId);
            const quiz = fetchedQuizzes.find(q => q.id === quizId);
            if (!quiz) return alert('Quiz not found');

            const questions = quiz.questions;
            const nextQuestionIndex = questions.findIndex(q => q.flag === 0);
            if (nextQuestionIndex === -1) {
                return alert('All questions have already been marked.');
            }
            questions[nextQuestionIndex].flag = 1;
            await axios.post('https://rvapi.emedha.in/pages/api/api/next/quiz_questions', {
                quizId,
                questionIndex: nextQuestionIndex,
                flag: 1,
            });
            fetchQuizzes();
            // ✅ Restart live fetching
            setTimeout(() => {
                setLiveFetching(true);
            }, 1000); // resume after 1 second
        } catch (err) {
            console.error('Error updating question flag:', err);
            alert('Failed to update the question.');
        }
    };


    return (
        <>
            <div className="container-fluid p-0">
                <div className="p-4" style={{ width: '350px', height: '100vh', position: 'fixed', top: 0, left: sidebarOpen ? 0 : '-350px', backgroundColor: '#f8f9fa', borderRight: '1px solid #dee2e6', padding: '20px', transition: 'left 0.3s ease-in-out', zIndex: 1000, overflowY: 'auto', }}>
                    <h5>My interactions</h5>
                    <div>
                        <button className="btn w-100 mb-3" style={{ border: '2px solid grey', borderRadius: '10px' }} onClick={() => { setAddingQuiz(true); setStep(1); }}><AiOutlinePlus className="me-2" /> Add Quiz</button>
                        <button className="btn w-100 mb-3" style={{ border: '2px solid grey', borderRadius: '10px' }}><BiSpreadsheet className="me-2" /> Templates</button>
                    </div>
                    <p><strong>Audience Q&A</strong></p>
                    <p className="text-muted small d-flex align-items-center" style={{ border: '2px solid grey', padding: '10px', borderRadius: '10px', }}><BiMessageDetail size={20} className="me-2" />Add Q&A to collect questions from your audience</p>
                    <p><strong>Polls</strong></p>
                    <p className="text-muted small">Your interactions will appear here</p>

                    <div>
                        <h6 className="d-flex justify-content-between align-items-center">
                            <span className="text-muted small">Total Questions: {submittedQuizzes.reduce((total, quiz) => total + quiz.questions.length, 0)}</span>
                        </h6>
                        {fetchedQuizzes.map((quiz, index) => (
                            <div key={quiz.id || index} className="mb-4 p-3 border rounded shadow-sm position-relative">
                                <div className="d-flex justify-content-between align-items-center mb-2">
                                    <h5
                                        style={{ cursor: 'pointer', userSelect: 'none', marginBottom: 0 }}
                                        onClick={() => setExpandedQuizId1(expandedQuizId1 === quiz.id ? null : quiz.id)}
                                        className="d-flex align-items-center"
                                        onMouseOver={e => e.currentTarget.style.color = '#0d6efd'}
                                        onMouseOut={e => e.currentTarget.style.color = 'inherit'}
                                    >
                                        <FaQuestionCircle className="me-2" />
                                        {quiz.title}
                                    </h5>

                                    <Dropdown>
                                        <Dropdown.Toggle variant="light" size="sm" id={`dropdown-${index}`}><CiMenuKebab /></Dropdown.Toggle>
                                        <Dropdown.Menu className="shadow-sm border-0">
                                            <Dropdown.Item onClick={() => { const link = `${window.location.origin}/view-quiz/${quiz.id}`; navigator.clipboard.writeText(link); alert('🔗 Link copied to clipboard!'); }} className="d-flex align-items-center gap-2">
                                                <FaRegCopy /> Copy Link
                                            </Dropdown.Item>
                                            <Dropdown.Item as="button" onClick={() => handleDeleteQuiz(quiz.id)} className="d-flex align-items-center gap-2 text-danger">
                                                <FaTrash /> Delete Quiz
                                            </Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>

                                {expandedQuizId1 === quiz.id && quiz.questions && (
                                    <div className="ps-4 mt-3">
                                        {quiz.questions.map((q, qIndex) => (
                                            <div key={qIndex} className="mb-3">
                                                <h6 className="d-flex align-items-center">
                                                    <strong className="me-2">{qIndex + 1}.</strong> {q.question}
                                                    <FaClock className="ms-3 text-muted" />
                                                    <small className="text-muted ms-1">Timer: {q.timer < 60 ? `${q.timer} sec` : `${q.timer / 60} min`}</small>
                                                </h6>
                                                <ul className="list-group list-group-flush">
                                                    {q.options.map((opt, i) => (
                                                        <li key={i} className={`list-group-item d-flex justify-content-between align-items-center ${q.correctAnswer === i ? 'list-group-item-success' : ''}`} style={{ border: 'none', paddingLeft: 0 }}>
                                                            <span>{String.fromCharCode(65 + i)}. {opt}</span>
                                                            {q.correctAnswer === i && <FaCheck className="text-success" />}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        ))}
                                    </div>
                                )}
                            </div>
                        ))}

                    </div>
                </div>

                <div className="p-4" style={{ marginLeft: sidebarOpen ? '350px' : '0', transition: 'margin-left 0.3s ease-in-out', }}>
                    <div className="p-3 d-flex align-items-center justify-content-start mb-4" style={{ border: '2px solid lightgrey', borderRadius: '10px' }}>
                        <button className="btn btn-outline-secondary me-3" onClick={toggleSidebar} style={{ zIndex: 1100 }}><AiOutlineMenu /></button>
                        <img src={events?.[0]?.file || ''} alt="Logo" className="img-fluid me-3" style={{ maxWidth: '60px', height: 'auto' }} />
                        <h2 className="mb-0 text-truncate" style={{ maxWidth: '100%' }}>
                            {events?.[0]?.name || 'No event available'}
                        </h2>
                    </div>

                    {addingQuiz && step === 1 && (
                        <form onSubmit={handleTitleSubmit} className="p-4" style={{ border: '2px solid lightgrey', borderRadius: '10px' }}>
                            <h4>Enter Quiz Title</h4>
                            <input type="text" className="form-control mb-3" value={quizTitle} onChange={(e) => setQuizTitle(e.target.value)} placeholder="Quiz Title" autoFocus />
                            <button type="submit" className="btn btn-sm btn-primary me-2">Next</button>
                            <button type="button" className="btn btn-secondary btn-sm" onClick={() => { setAddingQuiz(false); setStep(0); setQuizTitle(''); }}>Cancel</button>
                        </form>
                    )}

                    <>
                        {addingQuiz && step === 2 && (
                            <>
                                <div className="p-4" style={{ border: '2px solid lightgrey', borderRadius: '10px', maxHeight: '500px', overflowY: 'auto' }}>
                                    <div className="mb-3">
                                        <div className="d-flex justify-content-between align-items-center mb-1">
                                            <div><strong>1</strong> &nbsp; Quiz Question</div>
                                            <div className="d-flex align-items-center">
                                                <label htmlFor="quizTimer" className="me-2">Change Quiz Timer:</label>
                                                <select id="quizTimer" className="form-select form-select-sm" style={{ width: '100px' }} value={quizTimer} onChange={(e) => setQuizTimer(Number(e.target.value))}>
                                                    <option value="10">10s</option>
                                                    <option value="20">20s</option>
                                                    <option value="30">30s</option>
                                                    <option value="40">40s</option>
                                                    <option value="50">50s</option>
                                                    <option value="60">1m</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="d-flex justify-content-between text-muted" style={{ fontSize: '0.9rem' }}>
                                            <span>0 votes</span>
                                            <span>• {quizTimer < 60 ? `${quizTimer} sec` : `${quizTimer / 60} min`}</span>
                                        </div>
                                        <input type="text" className="form-control mb-2" placeholder="What Would You like to ask?" value={quizQuestion} onChange={(e) => setQuizQuestion(e.target.value)} />
                                        <p className="p-2 d-flex align-items-center" style={{ border: '2px solid lightgrey', borderRadius: '10px' }}>
                                            <span className="me-2 d-inline-flex justify-content-center align-items-center" style={{ width: '24px', height: '24px', borderRadius: '50%', backgroundColor: '#e0e0e0', color: '#333', fontSize: '16px', flexShrink: 0 }}>
                                                <MdInfoOutline />
                                            </span> Don’t forget to mark the correct answer
                                        </p>
                                    </div>

                                    {/* Options */}
                                    <div className="mb-3">
                                        {options.map((opt, idx) => (
                                            <div key={idx} className='p-2'>
                                                <label style={{ display: 'flex', alignItems: 'center', marginBottom: '8px', cursor: 'pointer' }}>
                                                    <input type="radio" name="correctAnswer" checked={correctAnswerIndex === idx} onChange={() => setCorrectAnswerIndex(idx)} style={{ display: 'none' }} />
                                                    <span style={{ height: '20px', width: '20px', borderRadius: '50%', border: '2px solid black', display: 'flex', alignItems: 'center', justifyContent: 'center', marginRight: '10px', backgroundColor: correctAnswerIndex === idx ? '#007bff' : 'transparent', transition: '0.2s' }}>
                                                        {correctAnswerIndex === idx && <FaCheck style={{ color: 'white', fontSize: '12px' }} />}
                                                    </span>
                                                    <input className="form-control" style={{ flex: 1 }} value={opt} onChange={(e) => updateOption(idx, e.target.value)} placeholder={`Option ${idx + 1}`} />
                                                    <FaTrash onClick={(e) => { e.stopPropagation(); deleteOption(idx); }} style={{ marginLeft: '10px', cursor: 'pointer', flexShrink: 0 }} title="Delete option" />
                                                </label>
                                            </div>
                                        ))}
                                        <button className="btn btn-sm w-100 text-start mt-4" onClick={addOption}>+ Add Option</button>
                                    </div>

                                    {/* Action Buttons */}
                                    <button className="btn btn-success me-2" onClick={handleQuizSubmit}>+ Add Another Quiz Question</button>
                                    <button className="btn btn-secondary" onClick={() => {
                                        setAddingQuiz(false);
                                        setStep(0);
                                        setQuizTitle('');
                                        setQuizQuestion('');
                                        setOptions(['', '']);
                                        setCorrectAnswerIndex(null);
                                        setQuizTimer(20);
                                    }}>Cancel</button>
                                </div>
                            </>
                        )}
                    </>

                    <div className='mt-5'>
                        {fetchedQuizzes.map((quiz, index) => (
                            <div key={quiz.id || index} className="mb-4 p-3 border rounded shadow-sm">
                                <h5 style={{ cursor: 'pointer', userSelect: 'none' }} onClick={() => {
                                    setExpandedQuizId(expandedQuizId === quiz.id ? null : quiz.id);
                                    setExpandedParticipantQuizId(null);
                                }} className="d-flex align-items-center justify-content-between">
                                    <div className="d-flex align-items-center flex-grow-1"><FaQuestionCircle className="me-2" /><span className="me-2">{quiz.title}</span><HiArrowDown /></div>
                                    <div className="d-flex align-items-center gap-2">
                                        <button className="btn btn-primary" onClick={() => {
                                            const isSame = activeChatQuizId === quiz.id;
                                            if (!isSame) { fetchParticipants(quiz.id); }
                                            setActiveChatQuizId(isSame ? null : quiz.id);
                                            setExpandedQuizId(null);
                                            setExpandedParticipantQuizId(null);
                                        }}>🚀 Start Interaction
                                        </button>
                                        <button className="btn btn-outline-info d-flex align-items-center" onClick={async () => {
                                            const isSame = expandedParticipantQuizId === quiz.id;
                                            if (!isSame) { await fetchParticipants(quiz.id); }
                                            setExpandedParticipantQuizId(isSame ? null : quiz.id);
                                            setExpandedQuizId(null);
                                            setActiveChatQuizId(null);
                                        }}><AiOutlineEye className="me-2" /> View as Participant
                                        </button>
                                        <button className="btn btn-outline-danger"><FaTrash onClick={() => handleDeleteQuiz(quiz.id)} title="Delete quiz" style={{ cursor: 'pointer' }} /></button>
                                    </div>
                                </h5>

                                {/* {expandedQuizId === quiz.id && expandedParticipantQuizId !== quiz.id && quiz.questions && (
                                    <div className="ps-4 mt-3">
                                        {quiz.questions.map((q, qIndex) => (
                                            <div key={qIndex} className="mb-3">
                                                <h6 className="d-flex align-items-center">
                                                    <strong className="me-2">{qIndex + 1}.</strong> {q.question}
                                                    <FaClock className="ms-3 text-muted" />
                                                    <small className="text-muted ms-1">Timer: {q.timer < 60 ? `${q.timer} sec` : `${q.timer / 60} min`}</small>
                                                </h6>

                                                <ul className="list-group list-group-flush">
                                                    {q.options.map((opt, i) => (
                                                        <li key={i} className={`list-group-item d-flex justify-content-between align-items-center ${q.correctAnswer === i ? 'list-group-item-success' : ''}`} style={{ border: 'none', paddingLeft: 0 }}>
                                                            <span>{String.fromCharCode(65 + i)}. {opt}</span>
                                                            {q.correctAnswer === i && <FaCheck className="text-success" />}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        ))}
                                    </div>
                                )} */}

                                {expandedParticipantQuizId === quiz.id && activeChatQuizId !== quiz.id && (
                                    <div className="mt-3 ps-4">
                                        <h6>Participants:({participants[quiz.id]?.length || 0})</h6>
                                        {participants[quiz.id]?.length > 0 ? (
                                            <ul className="list-group">
                                                {participants[quiz.id].map((p) => (
                                                    <li key={p.id} className="list-group-item d-flex align-items-center justify-content-between border-0 border-bottom py-2" style={{ cursor: 'pointer' }}>
                                                        <div className="d-flex align-items-center">
                                                            <div className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center me-3" style={{ width: 45, height: 45, fontWeight: 'bold', fontSize: '1rem' }}>{getInitials(p.name)}</div>
                                                            <div><div className="fw-semibold">{p.name}</div><div className="text-muted small">Joined</div></div>
                                                        </div>
                                                        <div className="text-muted small text-end" style={{ minWidth: '100px' }}>
                                                            {new Date(p.joined_at).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}
                                                        </div>
                                                    </li>
                                                ))}
                                            </ul>
                                        ) : (
                                            <p className="text-muted">No participants yet.</p>
                                        )}
                                    </div>
                                )}

                                {activeChatQuizId === quiz.id && (
                                    <div className="whatsapp-panel border rounded shadow-sm bg-light d-flex flex-column" style={{ width: '100%', height: '500px' }} >
                                        <div className="p-3 border-bottom"><h6 className="mb-0">Participants({participants[quiz.id]?.length || 0})</h6></div>
                                        <div className="flex-grow-1 overflow-auto px-3 py-2">
                                            <ul className="list-group list-group-flush">
                                                {participants[quiz.id]?.map((p) => {
                                                    const participantResult = results.find((r) => r.name === p.name);
                                                    return (
                                                        <li key={p.id} className="list-group-item border-0 px-0 py-2">
                                                            <div className="d-flex align-items-center">
                                                                <div className="rounded-circle bg-primary text-white d-flex justify-content-center align-items-center me-3" style={{ width: 40, height: 40 }}>
                                                                    {getInitials(p.name)}
                                                                </div>
                                                                <div>
                                                                    <div className="fw-bold">{p.name}</div>
                                                                    {participantResult ? (
                                                                        <ul className="list-unstyled mt-1 mb-0">
                                                                            {participantResult.answers.map((ans) => {
                                                                                const correctPercent = ans.is_correct ? 100 : 0;
                                                                                const wrongPercent = 100 - correctPercent;
                                                                                return (
                                                                                    <li key={ans.id} className="mb-2">
                                                                                        <div className="d-flex align-items-center mb-1">
                                                                                            <span className="me-2">Q{ans.question_index + 1}:</span>
                                                                                            <span className={`me-2 ${ans.is_correct ? "text-success" : "text-danger"}`}>
                                                                                                {ans.is_correct ? "✅ Correct" : "❌ Wrong"}
                                                                                            </span>
                                                                                            <small className="text-muted">({ans.submitted_time})</small>
                                                                                        </div>

                                                                                        <div className="progress" style={{ height: "15px" }}>
                                                                                            <div className="progress-bar bg-success" role="progressbar" style={{ width: `${correctPercent}%` }}>
                                                                                                {correctPercent > 0 && `✅ ${correctPercent}%`}
                                                                                            </div>
                                                                                            <div className="progress-bar bg-danger" role="progressbar" style={{ width: `${wrongPercent}%` }}>
                                                                                                {wrongPercent > 0 && `❌ ${wrongPercent}%`}
                                                                                            </div>
                                                                                        </div>
                                                                                    </li>
                                                                                );
                                                                            })}
                                                                        </ul>
                                                                    ) : (
                                                                        <div className="text-muted">No answers submitted.</div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </li>
                                                    );
                                                })}
                                            </ul>
                                        </div>

                                        <div className="p-3 border-top d-flex gap-2">
                                            {/* <button
                                                className="btn btn-danger btn-sm"
                                                onClick={() => {
                                                    fetch('http://localhost:4008/pages/api/api/reveal-answers', {
                                                        method: 'POST',
                                                        headers: { 'Content-Type': 'application/json' },
                                                        body: JSON.stringify({ quizId: quiz.id })
                                                    })
                                                        .then(res => res.json())
                                                        .then(data => {
                                                            if (data.message) {
                                                                alert(data.message);
                                                            } else {
                                                                alert('Reveal failed.');
                                                            }
                                                        })
                                                        .catch(err => {
                                                            console.error(err);
                                                            alert('Something went wrong.');
                                                        });
                                                }}
                                            >
                                                Reveal Answers
                                            </button> */}

                                            <button className="btn btn-success btn-sm" onClick={() => handleNextQuestion(quiz.id)}>➡ {getOrdinal(quiz.questions.filter(q => q.flag === 1).length)} Question</button>
                                        </div>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </>
    );
};

export default Quiz;
